import { ReactComponent as FlexibookLogoMark } from "../../../assets/flexibook-logo-mark.svg";
// Anyspot ships no separate icon mark, so the sidebar slot renders the full wordmark.
import { ReactComponent as AnyspotLogo } from "../../../assets/anyspot-logo.svg";
import { BRAND, getBrand } from "../../../utility/branding";

const BrandLogoMark = (props) =>
  getBrand() === BRAND.ANYSPOT ? <AnyspotLogo {...props} /> : <FlexibookLogoMark {...props} />;

export default BrandLogoMark;
